<div class="status-popover">
  <div class="status-option" *ngFor="let status of statuses; trackBy: trackByUserState" (click)="selectStatus(status.userState)" [class.disabled]="status.disabled">
    <ion-icon name="ellipse" [style.color]="status.color"></ion-icon>
    <span>{{ status.statusDisplayTxt }}</span>
    <ion-icon *ngIf="status.selected" name="checkmark-outline"></ion-icon>
  </div>
</div>